import { call, put, takeLatest, select } from 'redux-saga/effects';
import { StatusCodes } from 'http-status-codes';
import isEqual from 'lodash/isEqual';
import invokeApi from '../network';
import networkConfig from '../network/config';
import { getCustomerInfo } from '../redux/Actions/OrderservAction';
import SharedUtils from '../utils/SharedUtils';
import { setErrorCode } from '../redux/Actions/ErrorAction';
import { FETCH_MENU, FETCH_MENU_SUCCESS, FETCH_MENU_SUCCESS_UNCHANGED, FETCH_MENU_ERROR, FETCH_ITEM_DETAILS, FETCH_ITEM_DETAILS_SUCCESS, FETCH_ITEM_DETAILS_ERROR, RECOMMENDED_PRODUCT, RECOMMENDED_PRODUCT_SUCCESS, RECOMMENDED_PRODUCT_FAILURE, SET_ITEM_FAVOURITE, SET_ITEM_UN_FAVOURITE, SET_ITEM_FAVOURITE_SUCCESS, SET_ITEM_UNFAVOURITE_SUCCESS, } from '../constants';
import Strings from '../constants/Strings';
import { MenuUtils } from '../utils/MenuUtils';
const { filterCatalogByExclusionAndAvailability, createFlatList, clearMasterList } = MenuUtils;
function* handleSuccessResponse(menuResponse, exclusionsResponse, scheduledDateTime, tenantDateFormat, sucessCallBack) {
    const exclusionsResponses = exclusionsResponse?.response ? [exclusionsResponse?.response] : [];
    const actualMenuResponse = JSON.parse(JSON.stringify(menuResponse));
    const response = filterCatalogByExclusionAndAvailability(menuResponse?.response, exclusionsResponses, scheduledDateTime);
    clearMasterList(response?.id);
    const flatResponse = createFlatList(JSON.parse(JSON.stringify(response) ?? '{}'));
    const timeSpecificResponse = actualMenuResponse?.response?.categories[0]?.categories?.filter((category) => category?.isTimeSpecific);
    yield put({
        type: FETCH_MENU_SUCCESS,
        response,
        flatResponse,
        lastModified: menuResponse?.headers[Strings.menuResHeaderLastModified] ?? '',
        tenantDateFormat,
        exclusionsResponse: exclusionsResponses?.[0],
        timeSpecificResponse,
    });
    sucessCallBack && sucessCallBack();
    return response;
}
const callbackOnSuccess = (sucessCallBack) => sucessCallBack && sucessCallBack();
// eslint-disable-next-line sonarjs/cognitive-complexity
export function* fetchMenu(menuParam) {
    try {
        const menuConfig = networkConfig.menu;
        const header = {};
        const { menuPayload: { catalogName = '', tenantId = '' } = {}, exclusionPayload = {} } = menuParam;
        const { channel = '', storeId = '' } = exclusionPayload;
        const { fulfillment: { scheduled = {} } = {}, lastModified = '', response: prevMenuResponse, exclusionsResponse: prevExclusionResponse, response: { id = '' } = {}, } = yield select((state) => state.menuReducer) ?? {};
        let scheduledDateTime = scheduled;
        if (Object.keys(scheduledDateTime).length === 0) {
            const time = yield select((state) => state.cartReducer?.cartData?.requestedDateTime?.futureDateTime) ?? 0;
            scheduledDateTime = { date: '', key: '', time };
        }
        const menuData = {
            queryProps: menuParam.menuPayload,
            // disableHeaders: true
        };
        const tenantReducer = yield select((state) => state.tenantReducer);
        const allowScheduleOrderForDispositions = tenantReducer?.componentOptions?.[channel]?.scheduledDelivery?.allowScheduleOrderForDispositions ?? [];
        let exclusionConfig = networkConfig.exclusions;
        const futureExclusionsCall = SharedUtils.futureMenuExclusionCall(exclusionPayload, allowScheduleOrderForDispositions);
        let payload = null;
        let exclusionData = {};
        const headers = {
            'x-tenant-id': tenantId,
        };
        if (storeId) {
            exclusionData = {
                queryProps: exclusionPayload,
            };
            if (futureExclusionsCall) {
                exclusionConfig = networkConfig.futureExclusions;
                exclusionData = {};
                payload = { ...exclusionPayload };
            }
        }
        const exclusionsResponse = yield call(invokeApi, exclusionConfig, exclusionData, headers, payload);
        if (lastModified && catalogName === id && isEqual(exclusionsResponse?.response, prevExclusionResponse)) {
            header[Strings.menuReqHeaderIfModifiedSince] = lastModified;
        }
        const menuResponse = yield call(invokeApi, menuConfig, menuData, header);
        if (menuResponse.status >= StatusCodes.BAD_REQUEST) {
            yield put(setErrorCode(menuResponse.status));
        }
        if (exclusionsResponse?.status >= StatusCodes.BAD_REQUEST) {
            yield put(setErrorCode(exclusionsResponse?.status));
        }
        const getTenant = (state) => state.tenantReducer;
        const tenantData = yield select(getTenant);
        const tenantDateFormat = tenantData.dateFormat;
        const sucessCallBack = menuParam.sucessCallBack;
        if (menuResponse?.response && exclusionsResponse && tenantDateFormat) {
            yield call(handleSuccessResponse, menuResponse, exclusionsResponse, scheduledDateTime, tenantDateFormat, sucessCallBack);
        }
        else if (prevMenuResponse &&
            tenantDateFormat &&
            exclusionsResponse &&
            !isEqual(exclusionsResponse?.response, prevExclusionResponse)) {
            const menuResponseData = {
                response: prevMenuResponse,
                headers: {
                    [Strings.menuResHeaderLastModified]: lastModified,
                },
            };
            yield call(handleSuccessResponse, menuResponseData, exclusionsResponse, scheduledDateTime, tenantDateFormat, sucessCallBack);
        }
        else if (!menuResponse?.response && menuResponse.status === StatusCodes.NOT_MODIFIED) {
            yield put({
                type: FETCH_MENU_SUCCESS_UNCHANGED,
            });
            callbackOnSuccess(sucessCallBack);
        }
        else {
            yield put({
                type: FETCH_MENU_ERROR,
            });
        }
    }
    catch (error) {
        yield put({
            type: FETCH_MENU_ERROR,
        });
    }
}
export function* menuSaga() {
    yield takeLatest(FETCH_MENU, fetchMenu);
}
export function* fetchItemDetails(params) {
    try {
        const detailsData = {
            queryProps: params?.payload,
        };
        const { tenantId } = params?.payload;
        const { response, status } = yield call(invokeApi, networkConfig.itemDetails, detailsData, {
            'x-tenant-id': tenantId,
        });
        if (status >= 400) {
            yield put(setErrorCode(status));
        }
        if (response) {
            clearMasterList();
            const flatListData = createFlatList(JSON.parse(JSON.stringify(response) ?? '{}'));
            yield put({
                type: FETCH_ITEM_DETAILS_SUCCESS,
                flatListData,
                detailsResponse: response,
            });
            params.sucessCallBack && params.sucessCallBack();
        }
        else {
            yield put({
                type: FETCH_ITEM_DETAILS_ERROR,
            });
        }
    }
    catch (error) {
        yield put({
            type: FETCH_ITEM_DETAILS_ERROR,
        });
    }
}
export function* recommendedProduct(params) {
    try {
        const getTenant = (state) => state.tenantReducer;
        const tenantData = yield select(getTenant);
        const detailsData = {
            queryProps: params?.payload,
        };
        const { response, status } = yield call(invokeApi, networkConfig.recommendedProducts, detailsData, {
            'x-tenant-id': tenantData.tenantId,
        });
        if (status >= 400) {
            yield put(setErrorCode(status));
        }
        if (response) {
            yield put({
                type: RECOMMENDED_PRODUCT_SUCCESS,
                detailsResponse: response,
            });
        }
        else {
            yield put({
                type: RECOMMENDED_PRODUCT_FAILURE,
            });
        }
    }
    catch (error) {
        yield put({
            type: RECOMMENDED_PRODUCT_FAILURE,
        });
    }
}
export function* itemDetailsSaga() {
    yield takeLatest(FETCH_ITEM_DETAILS, fetchItemDetails);
}
export function* recommendedProductSaga() {
    yield takeLatest(RECOMMENDED_PRODUCT, recommendedProduct);
}
export function* addItemToFavouriteCart(request) {
    const phoneNumber = SharedUtils.getPhoneNumberFromToken();
    const customerPayload = {
        customerId: request?.payload?.customerId,
        tenantId: request?.payload?.tenantId,
        phoneNumber,
        updateUserData: true,
    };
    const { status: favStatus } = yield call(invokeApi, networkConfig.addItemToFav, { queryProps: { customerId: request?.payload?.customerId } }, {
        'x-tenant-id': request?.payload?.tenantId,
        'x-is-registered-user': 'true',
        'x-user-id': request?.payload?.customerId,
        'Content-Type': 'application/json',
    }, request?.postBody);
    yield put(getCustomerInfo(customerPayload));
    if (favStatus === StatusCodes.OK)
        yield put({ type: SET_ITEM_FAVOURITE_SUCCESS });
}
export function* addItemToFavouriteSaga() {
    yield takeLatest(SET_ITEM_FAVOURITE, addItemToFavouriteCart);
}
export function* addItemUnFavouriteCall(request) {
    const phoneNumber = SharedUtils.getPhoneNumberFromToken();
    const customerPayload = {
        customerId: request?.payload?.customerId,
        tenantId: request?.payload?.tenantId,
        phoneNumber,
        updateUserData: true,
    };
    const { status: unFavStatus } = yield call(invokeApi, networkConfig.removeFavItem, {
        queryProps: {
            customerId: request?.payload?.customerId,
            itemId: request?.payload?.itemId,
        },
    }, {
        'x-tenant-id': request?.payload?.tenantId,
        'x-is-registered-user': 'true',
        'x-user-id': request?.payload?.customerId,
    });
    yield put(getCustomerInfo(customerPayload));
    if (unFavStatus === StatusCodes.OK)
        yield put({ type: SET_ITEM_UNFAVOURITE_SUCCESS });
}
export function* addItemUnFavouriteSaga() {
    yield takeLatest(SET_ITEM_UN_FAVOURITE, addItemUnFavouriteCall);
}
